module.exports={foo:"bar"};